import {
  Button,
  Checkbox,
  Col,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
  DatePicker,
} from 'antd';
import ja_JP from 'antd/lib/date-picker/locale/ja_JP';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { notificationError } from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { JuchuData } from '../../common/objectType/JuchuData';
import { JuchuDetailData } from '../../common/objectType/JuchuDetailData';
import { Session } from '../../common/objectType/Session';
import { generateMessage } from '../../common/util/MessageUtil';
import ColorSearch from '../../pages/color/ColorSearch';
import ProductSearch from '../../pages/seihin/ProductSearch';
import JuchuNyuryokuServ from '../../services/JuchuNyuryokuServ';
import {
  JuchuNyuryokuDetailCtrl1,
  JuchuNyuryokuDetailCtrl2,
  JuchuNyuryokuDetailCtrl3,
  JuchuNyuryokuDetailCtrl4,
  JuchuNyuryokuDetailCtrl5,
} from './DisplayCtrl';
import { RequiredDetails, checkDateData, checkMomentData, checkRequired } from './Validation';

interface IProps {
  session: Session;
  juchuData: JuchuData;
  juchuDetailData: JuchuDetailData;
  dispJuchuDetailData: JuchuDetailData;
  juchuListData: any[];
  juchuListDelData: any[];
  updateJuchuListDelData: (data: any[]) => void;
  updateJuchuDetailData: (data: any) => void;
  updateDispJuchuDetailData: (data: any) => void;
  updateJuchuListlData: (data: any) => void;
  headerForm: FormInstance;
  detailForm: FormInstance;
  shoriSentaku: string;
  nonyuSaki?: number;
  clearFlg: boolean;
  updateClearFlg: (data: any) => void;
  loading: boolean;
  changeLoading: (data: any) => void;
}

const JuchuNyuryokuDetailEdit: React.FC<IProps> = (props: IProps) => {
  const { Option } = Select;
  const { TextArea } = Input;

  //#region state
  // 入目コンボボックスソース
  const [irimeDataOptions, updateIrimeDataOptions] = useState<any[]>([]);
  // 入目単位コンボボックスソース
  const [irimeTaniDataOptions, updateIrimeTaniDataOptions] = useState<any[]>([]);
  // 数量単位コンボボックスソース
  const [nisugataKbnDataOptions, updateNisugataKbnDataOptions] = useState<any[]>([]);
  // 艶コンボボックスソース
  const [tuyaDataOptions, updateTuyaDataOptions] = useState<any[]>([]);
  // サイズコンボボックスソース
  const [sizeDataOptions, updateSizeDataOptions] = useState<any[]>([]);
  // 形状コンボボックスソース
  const [hinShapeDataOptions, updateHinShapeDataOptions] = useState<any[]>([]);
  // 目地コンボボックスソース
  const [hinJointDataOptions, updateHinJointDataOptions] = useState<any[]>([]);
  // 基本色調コンボボックスソース
  const [kihonIro, updateKihonIro] = useState<string>('');
  const [kihonIroCdDataOptions, updateKihonIroCdDataOptions] = useState<any[]>([]);
  // 運送便コンボボックスソース
  const [unsoData, updateUnsoData] = useState<string>('');
  const [unsoDataOptions, updateUnsoDataOptions] = useState<any[]>([]);
  // 品目K区分
  const [hinmokuKbn, updateHinmokuKbn] = useState<string>('');
  // 現物色依頼区分
  const [geniraiKbn, updateGeniraiKbn] = useState<string>('');
  // 色調ポップアップ
  const [color, updateColor] = useState<string[]>([]);
  const [colorPop, updateColorPop] = useState(false);
  // 製品ポップアップ
  const [seihin, updateSeihin] = useState<string>('');
  const [seihinPop, updateSeihinPop] = useState(false);
  // 前回製品番号
  const [befSeihin, updateBefSeihin] = useState<string>('');
  //#endregion

  //#region useEffect
  // 全体クリア用
  useEffect(() => {
    if (props.clearFlg === true) {
      JuchuDetailDataClear();
      props.updateClearFlg(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.clearFlg]);

  // 納入先変更
  useEffect(() => {
    const init = async () => {
      if (props.nonyuSaki !== undefined) {
        // セット区分確認
        if (props.juchuDetailData.setKbn === '0' || props.juchuDetailData.setKbn === '1') {
          // 運送便コンボボックスソース取得
          await SelUnsoListData(props.juchuDetailData.hinCd, props.juchuData.adrKenCd);
          // 運送便初期値表示
          await ChgUnsoBin(
            props.headerForm.getFieldValue(JuchuData.FIELD_KEY_NAME.chartFlg),
            props.juchuData.tokCd,
            props.juchuData.tokCd2,
            props.juchuDetailData.hinCd,
            props.juchuData.adrKenCd,
            props.juchuData.adrSiCd
          );
          // 回答納期初期表示
          await ChgKaitoNoki(
            props.juchuData.tokCd,
            props.juchuData.tokCd2,
            props.juchuDetailData.hinCd,
            props.juchuData.adrKenCd,
            props.juchuData.adrSiCd
          );
          // 回答状況表示
          await ChgKaitoStatus();
        } else {
          // 得意先にない製品 or 子製品の場合
          props.detailForm.setFieldsValue({
            haiNm: '',
            kaijyoKbn: '',
            kaitoDt: '',
            kaitoKbn: '',
          });
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.nonyuSaki]);

  // 製品変更処理
  useEffect(() => {
    const init = async () => {
      props.detailForm.setFieldsValue({
        hinNm: props.juchuDetailData['hinNm'],
        irime: props.juchuDetailData['irime'],
        irimeKbn: props.juchuDetailData['irimeKbn'],
        tuyaCd: props.juchuDetailData['tuyaCd'],
        hinSize:
          befSeihin !== props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd)
            ? ''
            : props.juchuDetailData['hinSize'],
        hinShape:
          befSeihin !== props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd)
            ? ''
            : props.juchuDetailData['hinShape'],
        hinJoint:
          befSeihin !== props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd)
            ? ''
            : props.juchuDetailData['hinJoint'],
        irogNm: props.juchuDetailData['irogNm'],
        nisugataKbn: props.juchuDetailData['nisugataKbn'],
        haiNm: setHaiNm(),
      });

      let irimeResult: boolean = await SelIrimeList(
        props.juchuDetailData.hinKbn,
        props.juchuDetailData.hinCd,
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
      );

      if (
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== undefined &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== null &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== ''
      ) {
        if (irimeResult === true) {
          let irimeTaniResult: boolean = await SelIrimeTaniList(
            props.juchuDetailData.hinKbn,
            props.juchuDetailData.hinCd,
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
          );

          if (
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== undefined &&
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== null &&
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== ''
          ) {
            if (irimeTaniResult === true) {
              SelNisugataKbnList(
                props.juchuDetailData.hinKbn,
                props.juchuDetailData.hinCd,
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
              );
            }
          }
        }
      }

      SelTuyaList(props.juchuDetailData.hinCd);
      SelSizeList(props.juchuDetailData.hinCd);
      SelHinShapeList(props.juchuDetailData.hinCd);
      SelHinJointList(props.juchuDetailData.hinCd);
      SelUnsoListData(props.juchuDetailData.hinCd, props.juchuData.adrKenCd);
      updateHinmokuKbn(props.juchuDetailData.hinKbn || '0');
      SelKihonIroCdList(props.juchuDetailData.irogCd);
      updateBefSeihin(props.juchuDetailData.hinCd);
    };
    if (props.juchuDetailData !== undefined && Object.keys(props.juchuDetailData).length > 0) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.juchuDetailData['hinCd']]);

  // ダブルクリック処理
  useEffect(() => {
    const init = async () => {
      props.detailForm.setFieldsValue({
        ...props.juchuDetailData,
        // 現物色依頼区分が「'1'またはtrue」で判定する
        geniraiKbn:
          props.juchuDetailData.geniraiKbn === '1' || props.juchuDetailData.geniraiKbn === 'true'
            ? true
            : false,
        haiNm: setHaiNm(),
        syukkaDt: checkMomentData(props.juchuDetailData['syukkaDt'])
          ? moment(props.juchuDetailData['syukkaDt'])
          : undefined,
        kaitoDt: checkMomentData(props.juchuDetailData['kaitoDt']) // true
          ? moment(props.juchuDetailData['kaitoDt']) // moment(undefined) = moment() , null => moment(null).isValid() = false, moment(100).isValid() = true
          : undefined,
      });

      let irimeResult: boolean = await SelIrimeList(
        props.juchuDetailData.hinKbn,
        props.juchuDetailData.hinCd,
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
      );

      if (
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== undefined &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== null &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== ''
      ) {
        if (irimeResult === true) {
          let irimeTaniResult: boolean = await SelIrimeTaniList(
            props.juchuDetailData.hinKbn,
            props.juchuDetailData.hinCd,
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
          );

          if (
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== undefined &&
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== null &&
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== ''
          ) {
            if (irimeTaniResult === true) {
              SelNisugataKbnList(
                props.juchuDetailData.hinKbn,
                props.juchuDetailData.hinCd,
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
              );
            }
          }
        }
      }

      SelTuyaList(props.juchuDetailData.hinCd);
      SelSizeList(props.juchuDetailData.hinCd);
      SelHinShapeList(props.juchuDetailData.hinCd);
      SelHinJointList(props.juchuDetailData.hinCd);
      SelKihonIroCdList(props.juchuDetailData.irogCd);
      SelUnsoListData(props.juchuDetailData.hinCd, props.juchuData.adrKenCd);
      updateHinmokuKbn(props.juchuDetailData.hinKbn || '0');
      updateBefSeihin(props.juchuDetailData.hinCd);
    };
    if (
      props.dispJuchuDetailData !== undefined &&
      Object.keys(props.dispJuchuDetailData).length > 0
    ) {
      init();
      props.updateDispJuchuDetailData(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dispJuchuDetailData]);

  // 入目変更処理
  useEffect(() => {
    const init = async () => {
      props.detailForm.setFieldsValue({
        irime: props.juchuDetailData['irime'],
        irimeKbn: props.juchuDetailData['irimeKbn'],
        nisugataKbn: props.juchuDetailData['nisugataKbn'],
      });

      if (
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== undefined &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== null &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime) !== ''
      ) {
        let irimeTaniResult: boolean = await SelIrimeTaniList(
          props.juchuDetailData.hinKbn,
          props.juchuDetailData.hinCd,
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
        );

        if (
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== undefined &&
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== null &&
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== ''
        ) {
          if (irimeTaniResult === true) {
            SelNisugataKbnList(
              props.juchuDetailData.hinKbn,
              props.juchuDetailData.hinCd,
              props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
              props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
              props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
            );
          }
        }
      }
    };
    if (props.juchuDetailData !== undefined && Object.keys(props.juchuDetailData).length > 0) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.juchuDetailData['irime']]);

  // 入目単位変更処理
  useEffect(() => {
    const init = async () => {
      props.detailForm.setFieldsValue({
        irimeKbn: props.juchuDetailData['irimeKbn'],
        nisugataKbn: props.juchuDetailData['nisugataKbn'],
      });
      if (
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== undefined &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== null &&
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn) !== ''
      ) {
        SelNisugataKbnList(
          props.juchuDetailData.hinKbn,
          props.juchuDetailData.hinCd,
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize)
        );
      }
    };
    if (props.juchuDetailData !== undefined && Object.keys(props.juchuDetailData).length > 0) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.juchuDetailData['irimeKbn']]);

  // 基本色調変更処理
  useEffect(() => {
    const init = async () => {
      props.detailForm.setFieldsValue({
        irogCd: props.juchuDetailData['irogCd'],
        irogNm: props.juchuDetailData['irogNm'],
        hyoujiIroCd: props.juchuDetailData['hyoujiIroCd'],
        kihonIroCd: props.juchuDetailData['kihonIroCd'],
        genbutuNo: props.juchuDetailData['genbutuNo'],
        mihonNo: props.juchuDetailData['mihonNo'],
      });

      SelKihonIroCdList(props.juchuDetailData.irogCd);
    };
    if (props.juchuDetailData !== undefined && Object.keys(props.juchuDetailData).length > 0) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.juchuDetailData['kihonIroCd']]);

  // 現物色依頼区分を変更
  useEffect(() => {
    const init = async () => {
      if (geniraiKbn === '1') {
        if (
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo) !==
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd)
        ) {
          props.detailForm.setFieldsValue({ kihonIroCd: '', genbutuNo: '' });
        }
        props.detailForm.setFieldsValue({
          kaitoDt: '',
          kaitoKbn: '',
        });
      } else if (geniraiKbn === '0') {
        // 回答納期初期表示
        await ChgKaitoNoki(
          props.juchuData.tokCd,
          props.juchuData.tokCd2,
          props.juchuDetailData.hinCd,
          props.juchuData.adrKenCd,
          props.juchuData.adrSiCd
        );
      }
      // 回答状況表示
      await ChgKaitoStatus();
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geniraiKbn]);

  // 製品ポップから遷移
  useEffect(() => {
    if (seihin !== undefined && seihin !== null && seihin !== '') {
      if (seihin && seihinPop === false) {
        props.detailForm.setFieldsValue({
          hinCd: seihin,
        });
        ChgHinCd();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seihin]);

  // 色調ポップから遷移
  useEffect(() => {
    if (color !== undefined && color.length > 0 && colorPop === false) {
      props.updateJuchuDetailData({
        ...props.juchuDetailData,
        irogCd: color[0],
        irogNm: color[1],
        hyoujiIroCd: color[2],
        kihonIroCd: color[3],
        genbutuNo: color[4],
        mihonNo: color[5],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  // 表示色調が無い時基本色調をコピー
  useEffect(() => {
    if (kihonIro !== undefined && kihonIro !== null && kihonIro !== '') {
      props.detailForm.setFieldsValue({ hyoujiIroCd: kihonIro });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kihonIro]);

  // 運送便変更
  useEffect(() => {
    const init = async () => {
      if (unsoData !== undefined && unsoData !== null && unsoData !== '') {
        // 回答納期初期表示
        await ChgKaitoNoki(
          props.juchuData.tokCd,
          props.juchuData.tokCd2,
          props.juchuDetailData.hinCd,
          props.juchuData.adrKenCd,
          props.juchuData.adrSiCd
        );
        // 回答状況表示
        await ChgKaitoStatus();
      } else {
        props.detailForm.setFieldsValue({
          kaijyoKbn: '',
          kaitoDt: '',
          kaitoKbn: '',
        });
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unsoData]);
  //#endregion

  //#region function
  // 入目コンボボックスソース
  const SelIrimeList = async (hinKbn: string, hinCd: string, size: string): Promise<boolean> => {
    let irimeResult: boolean = false;
    if (hinKbn === '0') {
      size = '0';
    }
    await JuchuNyuryokuServ.selIrimeListData(hinCd, size)
      .then((json) => {
        updateIrimeDataOptions(json.data);
        if (json.data.length === 1) {
          props.detailForm.setFieldsValue({ irime: json.data[0].irime });
        } else if (json.data.length > 1) {
          const irimeValue = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime);
          if (irimeValue !== undefined) {
            let result: boolean = false;
            for (let index = 0; index < json.data.length; index++) {
              if (json.data[index].irime === irimeValue) {
                result = true;
              }
            }
            if (result === false) {
              DelIrime();
            }
          }
        } else {
          // 0件取得の場合クリア
          DelIrime();
        }

        irimeResult = true;
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '入目検索'));
      });
    return irimeResult;
  };

  // 入目が画面に元々表示されていた値に該当しない場合、入目、入目単位、荷姿を消去
  const DelIrime = () => {
    props.detailForm.setFieldsValue({ irime: '' });
    props.detailForm.setFieldsValue({ irimeKbn: '' });
    props.detailForm.setFieldsValue({ nisugataKbn: '' });
    updateIrimeTaniDataOptions([]);
    updateNisugataKbnDataOptions([]);
  };

  // 入目単位コンボボックスソース
  const SelIrimeTaniList = async (
    hinKbn: string,
    hinCd: string,
    irime: string,
    size: string
  ): Promise<boolean> => {
    let irimeTaniResult: boolean = false;
    if (hinKbn === '0') {
      await JuchuNyuryokuServ.selIrimeTaniListData(hinCd, irime)
        .then((json) => {
          updateIrimeTaniDataOptions(json.data);

          if (json.data.length === 1) {
            props.detailForm.setFieldsValue({ irimeKbn: json.data[0].irimeKbn });
          } else if (json.data.length > 1) {
            const irimeTaniValue = props.detailForm.getFieldValue(
              JuchuDetailData.FIELD_KEY_NAME.irimeKbn
            );
            if (irimeTaniValue !== undefined) {
              let result: boolean = false;
              for (let index = 0; index < json.data.length; index++) {
                if (json.data[index].irimeKbn === irimeTaniValue) {
                  result = true;
                }
              }
              if (result === false) {
                DelIrimeTani();
              }
            }
          } else {
            // 0件取得の場合クリア
            DelIrimeTani();
          }

          irimeTaniResult = true;
        })
        .catch((error) => {
          notificationError(
            `注文入力`,
            generateMessage(Message.ERROR_MASSAGE.ERR999, '入目単位検索')
          );
        });
    }
    if (hinKbn === '1') {
      await JuchuNyuryokuServ.selIrimeTaniMaListData(hinCd, size, irime)
        .then((json) => {
          updateIrimeTaniDataOptions(json.data);
          if (json.data.length === 1) {
            props.detailForm.setFieldsValue({ irimeKbn: json.data[0].irimeKbn });
          } else if (json.data.length > 1) {
            const irimeTaniValue = props.detailForm.getFieldValue(
              JuchuDetailData.FIELD_KEY_NAME.irimeKbn
            );
            if (irimeTaniValue !== undefined) {
              let result: boolean = false;
              for (let index = 0; index < json.data.length; index++) {
                if (json.data[index].irimeKbn === irimeTaniValue) {
                  result = true;
                }
              }
              if (result === false) {
                DelIrimeTani();
              }
            }
          } else {
            // 0件取得の場合クリア
            DelIrimeTani();
          }

          irimeTaniResult = true;
        })
        .catch((error) => {
          notificationError(
            `注文入力`,
            generateMessage(Message.ERROR_MASSAGE.ERR999, '入目単位検索')
          );
        });
    }
    if (hinKbn === undefined) {
      updateIrimeTaniDataOptions([]);
    }
    return irimeTaniResult;
  };

  // 入目単位が画面に元々表示されていた値に該当しない場合、入目単位、荷姿を消去
  const DelIrimeTani = () => {
    props.detailForm.setFieldsValue({ irimeKbn: '' });
    props.detailForm.setFieldsValue({ nisugataKbn: '' });
    updateNisugataKbnDataOptions([]);
  };

  // 数量単位コンボボックスソース
  const SelNisugataKbnList = (
    hinKbn: string,
    hinCd: string,
    irime: string,
    irimeTani: string,
    size: string
  ) => {
    if (hinKbn === '0') {
      size = '';
    }
    if (hinKbn === '1') {
      irime = '';
      irimeTani = '';
    }
    JuchuNyuryokuServ.selNisugataKbnListData(hinCd, irime, irimeTani, size)
      .then((json) => {
        updateNisugataKbnDataOptions(json.data);
        if (json.data.length === 1) {
          props.detailForm.setFieldsValue({ nisugataKbn: json.data[0].nisug });
        } else if (json.data.length > 1) {
          const nisugataKbnValue = props.detailForm.getFieldValue(
            JuchuDetailData.FIELD_KEY_NAME.nisugataKbn
          );
          if (nisugataKbnValue !== undefined) {
            let result: boolean = false;
            for (let index = 0; index < json.data.length; index++) {
              if (json.data[index].nisug === nisugataKbnValue) {
                result = true;
              }
            }
            if (result === false) {
              props.detailForm.setFieldsValue({ nisugataKbn: '' });
            }
          }
        }
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '数量単位検索')
        );
      });
  };

  // 艶コンボボックスソース
  const SelTuyaList = (hinCd: string) => {
    if (props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.setKbn) !== '2') {
      JuchuNyuryokuServ.selTuyaListData(hinCd)
        .then((json) => {
          updateTuyaDataOptions(json.data);

          if (json.data.length === 1) {
            props.detailForm.setFieldsValue({ tuyaCd: json.data[0].tuyaCd });
          } else if (json.data.length > 1) {
            const tuyaCdValue = props.detailForm.getFieldValue(
              JuchuDetailData.FIELD_KEY_NAME.tuyaCd
            );

            if (tuyaCdValue !== undefined) {
              let result: boolean = false;
              for (let index = 0; index < json.data.length; index++) {
                if (json.data[index].tuyaCd === tuyaCdValue) {
                  result = true;
                }
              }
              if (result === false) {
                props.detailForm.setFieldsValue({ tuyaCd: '' });
              }
            }
          } else {
            props.detailForm.setFieldsValue({ tuyaCd: '' });
          }
          // 入力された品番が子品番の場合、艶を選択できなくするテストケースに対応
          if (props.juchuDetailData.setKbn === undefined) {
            updateTuyaDataOptions([]);
          }
        })
        .catch((error) => {
          notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '艶検索'));
        });
    }
  };

  // サイズコンボボックスソース
  const SelSizeList = (hinCd: string) => {
    JuchuNyuryokuServ.selSizeListData(hinCd)
      .then((json) => {
        updateSizeDataOptions(json.data);
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, 'サイズ検索'));
      });
  };

  // 形状コンボボックスソース
  const SelHinShapeList = (hinCd: string) => {
    JuchuNyuryokuServ.selHinShapeListData(hinCd)
      .then((json) => {
        updateHinShapeDataOptions(json.data);
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '形状検索'));
      });
  };

  // 目地コンボボックスソース
  const SelHinJointList = (hinCd: string) => {
    JuchuNyuryokuServ.selHinJointListData(hinCd)
      .then((json) => {
        updateHinJointDataOptions(json.data);
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '目地検索'));
      });
  };

  // 基本色調コンボボックスソース
  const SelKihonIroCdList = (hinCd: string) => {
    JuchuNyuryokuServ.selKihonIroCdListData(hinCd)
      .then((json) => {
        updateKihonIroCdDataOptions(json.data);
        const kihonIroCdValue = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.kihonIroCd
        );
        let result: boolean = false;
        for (let index = 0; index < json.data.length; index++) {
          if (json.data[index].mkiroCd === kihonIroCdValue) {
            result = true;
          }
        }
        if (result === false) {
          if (props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn) !== true) {
            props.detailForm.setFieldsValue({ kihonIroCd: '' });
          }
        }
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '基本色調検索')
        );
      });
  };

  // 運送便コンボボックスソース
  const SelUnsoListData = async (hinCd: string, kenCd: string) => {
    JuchuNyuryokuServ.selUnsoListData(hinCd, kenCd)
      .then((json) => {
        updateUnsoDataOptions(json.data);
        const unsoValue = props.detailForm.getFieldValue('haiNm');
        let result: boolean = false;
        for (let index = 0; index < json.data.length; index++) {
          if (json.data[index].haiCd + '.' + json.data[index].haiCd2 === unsoValue) {
            result = true;
          }
        }
        if (result === false) {
          props.detailForm.setFieldsValue({ haiNm: '' });
        }
      })
      .catch((error) => {
        notificationError(`注文入力`, generateMessage(Message.ERROR_MASSAGE.ERR999, '運送便検索'));
      });
  };

  // 運送便（日本語）の設定
  const setHaiNm = () => {
    let haiNm: string = '';
    let dispHaiNm: string =
      props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';

    if (dispHaiNm === '') {
      if (
        props.juchuDetailData.haiCd !== undefined &&
        props.juchuDetailData.haiCd !== '' &&
        props.juchuDetailData.haiCd2 !== undefined &&
        props.juchuDetailData.haiCd2 !== ''
      ) {
        haiNm = props.juchuDetailData.haiCd + '.' + props.juchuDetailData.haiCd2;
      }
    } else {
      haiNm = dispHaiNm;
    }

    return haiNm;
  };

  // 運送便初期表示
  const ChgUnsoBin = async (
    chartFlg: boolean,
    tokCd: String,
    tokCd2: String,
    hinCd: String,
    kenCd: String,
    cityCd: String
  ) => {
    // チャーター便希望確認
    if (chartFlg !== true) {
      // 必須引数確認
      if (
        checkRequired(tokCd) &&
        checkRequired(tokCd2) &&
        checkRequired(hinCd) &&
        checkRequired(kenCd) &&
        checkRequired(cityCd)
      ) {
        // 運送便入力チェック
        let dispHaiNm: string =
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';
        if (dispHaiNm === undefined || dispHaiNm === null || dispHaiNm === '') {
          await JuchuNyuryokuServ.selUnsoBin(tokCd, tokCd2, hinCd, kenCd, cityCd)
            .then((json) => {
              let joinHaiNm = '';
              if (json.data['haiCd'] !== '' && json.data['haiCd2'] !== '') {
                joinHaiNm = json.data['haiCd'] + '.' + json.data['haiCd2'];
                props.detailForm.setFieldsValue({
                  haiNm: joinHaiNm,
                });
              }
            })
            .catch((error) => {
              notificationError(
                `注文入力`,
                generateMessage(Message.ERROR_MASSAGE.ERR999, '初期運送便検索')
              );
            });
        }
      }
    }
  };

  // 回答納期初期表示
  const ChgKaitoNoki = async (
    tokCd: String,
    tokCd2: String,
    hinCd: String,
    kenCd: String,
    cityCd: String
  ) => {
    // 運送便入力チェック
    let dispHaiNm: string =
      props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';
    if (dispHaiNm !== undefined && dispHaiNm !== null && dispHaiNm !== '') {
      let haiCd = dispHaiNm.split('.')[0];
      let haiCd2 = dispHaiNm.split('.')[1];
      // 必須引数確認
      if (
        checkRequired(tokCd) &&
        checkRequired(tokCd2) &&
        checkRequired(hinCd) &&
        checkRequired(kenCd) &&
        checkRequired(cityCd) &&
        checkRequired(haiCd) &&
        checkRequired(haiCd2)
      ) {
        await JuchuNyuryokuServ.selKaitoNoki(tokCd, tokCd2, hinCd, kenCd, cityCd, haiCd, haiCd2)
          .then((json) => {
            props.detailForm.setFieldsValue({
              kaitoDt: checkDateData(json.data['kaitoNoki'])
                ? moment(json.data['kaitoNoki'])
                : undefined,
              kaitoKbn: json.data['kaitoNokiKbn'],
            });
          })
          .catch((error) => {
            notificationError(
              `注文入力`,
              generateMessage(Message.ERROR_MASSAGE.ERR999, '初期回答納期検索')
            );
          });
      }
    }
  };

  // 回答状況表示
  const ChgKaitoStatus = async () => {
    let hinCd: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd);
    let geniraiKbn: boolean = props.detailForm.getFieldValue(
      JuchuDetailData.FIELD_KEY_NAME.geniraiKbn
    );
    let kaitoDt: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoDt);
    if (hinCd === undefined || hinCd === null || hinCd === '') {
      props.detailForm.resetFields(['kaijyoKbn']);
    } else if (geniraiKbn === true) {
      props.detailForm.setFieldsValue({
        kaijyoKbn: '1',
      });
    } else if (kaitoDt === undefined || kaitoDt === null || kaitoDt === '') {
      props.detailForm.setFieldsValue({
        kaijyoKbn: '0',
      });
    } else if (kaitoDt !== undefined || kaitoDt !== null || kaitoDt !== '') {
      props.detailForm.setFieldsValue({
        kaijyoKbn: '2',
      });
    }
  };

  // 現物色依頼区分変更
  const ChgGeniraiKbn = () => {
    let dispGeniraiKbn = props.detailForm.getFieldValue('geniraiKbn');
    if (dispGeniraiKbn === false) {
      updateGeniraiKbn('0');
      props.updateJuchuDetailData({
        ...props.juchuDetailData,
        geniraiKbn: '0',
      });
    } else {
      updateGeniraiKbn('1');
      props.updateJuchuDetailData({
        ...props.juchuDetailData,
        geniraiKbn: '1',
        kaitoDt: '',
        kihonIroCd: '',
        genbutuNo: '',
        kaitoKbn: '',
      });
    }
  };

  // 色調ポップを開く
  const showColorPop = () => {
    updateColorPop(true);
  };

  // 色調ポップを閉じる
  const closeColorPop = () => {
    updateColorPop(false);
  };

  // 製品コード検索
  const chkHinCd = async () => {
    let setKbn = '';
    let hinCd: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd) || '';
    await JuchuNyuryokuServ.selHinmokuData(
      props.juchuData.tokCd,
      props.juchuData.tokCd2,
      hinCd
    ).then((json) => {
      setKbn = json.data['setKbn'];
    });
    return setKbn;
  };

  // 製品コード変更
  const ChgHinCd = async () => {
    let hinCd: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd) || '';
    await JuchuNyuryokuServ.selHinmokuData(props.juchuData.tokCd, props.juchuData.tokCd2, hinCd)
      .then((json) => {
        updateHinmokuKbn(json.data['hinKKbn']);

        props.updateJuchuDetailData({
          ...props.juchuDetailData,
          hinCd: json.data['hinCd'],
          hinNm: json.data['hinNm'],
          irogCd: json.data['irogCd'],
          irogNm: json.data['irogNm'],
          hinKbn: json.data['hinKKbn'],
          setKbn: json.data['setKbn'],
          iroKbn: json.data['koteiIroFlg'],
          hinSize: '',
          hinShape: '',
          hinJoint: '',
        });
        return json;
      })
      .then(async (json) => {
        if (json.data['setKbn'] === '0' || json.data['setKbn'] === '1') {
          // 運送便初期値表示
          await ChgUnsoBin(
            props.headerForm.getFieldValue(JuchuData.FIELD_KEY_NAME.chartFlg),
            props.juchuData.tokCd,
            props.juchuData.tokCd2,
            json.data['hinCd'],
            props.juchuData.adrKenCd,
            props.juchuData.adrSiCd
          );
          // 回答納期初期表示
          await ChgKaitoNoki(
            props.juchuData.tokCd,
            props.juchuData.tokCd2,
            json.data['hinCd'],
            props.juchuData.adrKenCd,
            props.juchuData.adrSiCd
          );
          // 回答状況表示
          await ChgKaitoStatus();
        } else {
          // 得意先にない製品 or 子製品の場合
          props.detailForm.setFieldsValue({
            haiNm: '',
            kaijyoKbn: '',
            kaitoDt: '',
            kaitoKbn: '',
          });
        }
      })
      .catch((error) => {
        notificationError(
          `注文入力`,
          generateMessage(Message.ERROR_MASSAGE.ERR999, '製品情報検索')
        );
      });
  };

  // 入目変更
  const ChgIrime = () => {
    props.updateJuchuDetailData({
      ...props.juchuDetailData,
      irime: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
    });
    SelIrimeTaniList(
      props.juchuDetailData.hinKbn,
      props.juchuDetailData.hinCd,
      props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
      props.juchuDetailData.hinSize
    );
  };

  // サイズ変更
  const ChgSize = async () => {
    let hinCode = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd);
    let hinSize = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize);
    JuchuNyuryokuServ.selIrimeListData(hinCode, hinSize).then((json) => {
      updateIrimeDataOptions(json.data);
      let strIrime =
        json.data !== undefined && json.data !== null && json.data.length !== 0
          ? json.data[0]['irime']
          : null;
      props.detailForm.setFieldsValue({ irime: strIrime });
      JuchuNyuryokuServ.selIrimeTaniMaListData(hinCode, hinSize, strIrime).then((json) => {
        updateIrimeTaniDataOptions(json.data);
        props.detailForm.setFieldsValue({
          irimeKbn:
            json.data !== undefined && json.data !== null && json.data.length !== 0
              ? json.data[0]['irimeKbn']
              : null,
        });
      });
    });
    JuchuNyuryokuServ.selNisugataKbnListData(hinCode, '', '', hinSize).then((json) => {
      updateNisugataKbnDataOptions(json.data);
      props.detailForm.setFieldsValue({
        nisugataKbn:
          json.data !== undefined && json.data !== null && json.data.length !== 0
            ? json.data[0]['nisug']
            : null,
      });
    });
  };

  // 運送便変更
  const ChgHaiNm = (haiNm: string) => {
    updateUnsoData(haiNm);
  };

  // 基本色調変更
  const ChgKihon = () => {
    // 表示色調表示
    if (
      props.detailForm.getFieldValue('hyoujiIroCd') === undefined ||
      props.detailForm.getFieldValue('hyoujiIroCd') === null ||
      props.detailForm.getFieldValue('hyoujiIroCd') === ''
    ) {
      updateKihonIro(props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd));
    }
  };

  // 仮明細Noを発行
  const GetDispNo = () => {
    let dispNo: number = 1;
    for (let index = 0; index < props.juchuListData.length; index++) {
      dispNo = Number(props.juchuListData[index]['dispNo']) + 1;
    }
    return dispNo.toString();
  };

  // 明細編集追加ボタン処理
  const JuchuListDataAdd = async () => {
    if (props.loading) return;
    props.changeLoading(true);
    let hinCd: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd) || '';
    let haiNm: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';
    if (
      await RequiredDetails(
        hinCd,
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.jyuSu),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.mihonNo),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd)
      )
    ) {
      let hinData: any = await JuchuNyuryokuServ.checkHinmokuData(
        props.juchuData.tokCd,
        props.juchuData.tokCd2,
        hinCd
      );
      if (hinData.data === 'SUCCESS') {
        let urlData: any = await JuchuNyuryokuServ.selhaiUrl(
          haiNm.split('.')[0],
          haiNm.split('.')[1]
        );

        let data = {
          ...props.detailForm.getFieldsValue(),
          processKbn: '1',
          jyugyoNo: '',
          dispNo: GetDispNo(),
          geniraiKbn:
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn) === true ||
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn) === '1'
              ? '1'
              : '0',
          // hinCd: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd),
          // hinNm: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinNm),
          hinKbn: props.juchuDetailData['hinKbn'],
          setKbn: props.juchuDetailData['setKbn'],
          // irime: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
          // irimeKbn: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
          irimeNm:
            irimeTaniDataOptions.find(
              (item) => item['irimeKbn'] === props.detailForm.getFieldValue('irimeKbn')
            )?.irimeNm || null,
          tuyaCd: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.tuyaCd) || null,
          tuyaNm:
            tuyaDataOptions.find(
              (item) => item['tuyaCd'] === props.detailForm.getFieldValue('tuyaCd')
            )?.tuyaNm || null,
          hinSize:
            props.juchuDetailData['hinKbn'] === '1'
              ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize) || null
              : null,
          hinSizeNm:
            props.juchuDetailData['hinKbn'] === '1'
              ? sizeDataOptions.find(
                  (item) => item['seq'] === props.detailForm.getFieldValue('hinSize')
                )?.keyData1 || null
              : null,
          hinJoint:
            props.juchuDetailData['hinKbn'] === '1'
              ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinJoint) || null
              : null,
          hinJointNm:
            props.juchuDetailData['hinKbn'] === '1'
              ? hinJointDataOptions.find(
                  (item) => item['seq'] === props.detailForm.getFieldValue('hinJoint')
                )?.keyData1 || null
              : null,
          hinShape:
            props.juchuDetailData['hinKbn'] === '1'
              ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinShape) || null
              : null,
          hinShapeNm:
            props.juchuDetailData['hinKbn'] === '1'
              ? hinShapeDataOptions.find(
                  (item) => item['seq'] === props.detailForm.getFieldValue('hinShape')
                )?.keyData1 || null
              : null,
          irogCd: props.juchuDetailData['irogCd'],
          // irogNm: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irogNm),
          hyoujiIroCd:
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hyoujiIroCd) || '',
          kihonIroCd:
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd) || '',
          haiCd: haiNm.split('.')[0] || null,
          haiCd2: haiNm.split('.')[1] || null,
          haiNm:
            unsoDataOptions.find((item) => [item.haiCd, item.haiCd2].join('.') === haiNm)?.haiRnm +
              unsoDataOptions.find((item) => [item.haiCd, item.haiCd2].join('.') === haiNm)
                ?.haiRnm2 || null,
          haiUrlMae: urlData.data['haiUrlMae'] || null,
          haiUrlAto: urlData.data['haiUrlAto'] || null,
          // syukkaDt: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.syukkaDt),
          // okuriNo: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.okuriNo),
          genbutuNo: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo) || '',
          mihonNo: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.mihonNo) || '',
          kaijyoKbn:
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaijyoKbn) || null,
          kaitoNm:
            props.detailForm.getFieldValue('kaijyoKbn') === '0'
              ? '確認中'
              : props.detailForm.getFieldValue('kaijyoKbn') === '1'
              ? '納期保留'
              : props.detailForm.getFieldValue('kaijyoKbn') === '2'
              ? '仮確定'
              : props.detailForm.getFieldValue('kaijyoKbn') === '3'
              ? '確定'
              : null,
          kaitoDt: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoDt),
          ampmNm:
            props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '1'
              ? 'AM'
              : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '2'
              ? 'PM'
              : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '3'
              ? '頃'
              : null,
          kaitoKbn: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) || null,
          // jyuSu: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.jyuSu),
          // nisugataKbn: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn),
          nisugataNm:
            nisugataKbnDataOptions.find(
              (item) =>
                item['nisug'] ===
                props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn)
            )?.name || '',
          iroKbn: props.juchuDetailData['iroKbn'],
          iroBiko: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.iroBiko) || null,
          biko: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.biko) || null,
        };

        props.updateJuchuListlData((list: any) => {
          return [...list, data];
        });
        JuchuDetailDataClear();
      } else {
        notificationError('注文入力', Message.ERROR_MASSAGE.ERR010);
      }
    }
    props.changeLoading(false);
  };

  // 明細編集修正ボタン処理
  const JuchuListDataUpd = async () => {
    if (props.loading) return;
    props.changeLoading(true);
    let hinCd: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd) || '';
    let haiNm: string = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';
    let hinData: any = await JuchuNyuryokuServ.checkHinmokuData(
      props.juchuData.tokCd,
      props.juchuData.tokCd2,
      hinCd
    );
    if (hinData.data === 'SUCCESS') {
      if (
        await RequiredDetails(
          hinCd,
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.jyuSu),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.mihonNo),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn),
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd)
        )
      ) {
        let urlData: any = await JuchuNyuryokuServ.selhaiUrl(
          haiNm.split('.')[0],
          haiNm.split('.')[1]
        );
        let data = props.detailForm.getFieldsValue();
        await props.updateJuchuListlData((list: any[]) => {
          return list.map((item) => {
            if (item.dispNo === props.juchuDetailData.dispNo) {
              let tmpJyugyoNo = props.juchuDetailData.jyugyoNo;
              return {
                ...item,
                ...data,
                processKbn:
                  tmpJyugyoNo !== undefined && tmpJyugyoNo !== null && tmpJyugyoNo !== '' ? 2 : 1,
                dispNo:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.dispNo) ||
                  GetDispNo(),
                geniraiKbn:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn) ===
                    true ||
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn) === '1'
                    ? '1'
                    : '0',
                // hinCd: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd),
                // hinNm: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinNm),
                hinKbn: props.juchuDetailData['hinKbn'],
                setKbn: props.juchuDetailData['setKbn'],
                // irime: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
                // irimeKbn: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
                irimeNm:
                  irimeTaniDataOptions.find(
                    (item) => item['irimeKbn'] === props.detailForm.getFieldValue('irimeKbn')
                  )?.irimeNm || null,
                tuyaCd:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.tuyaCd) || null,
                tuyaNm:
                  tuyaDataOptions.find(
                    (item) => item['tuyaCd'] === props.detailForm.getFieldValue('tuyaCd')
                  )?.tuyaNm || null,
                hinSize:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinSize) || null
                    : null,
                hinSizeNm:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? sizeDataOptions.find(
                        (item) => item['seq'] === props.detailForm.getFieldValue('hinSize')
                      )?.keyData1 || null
                    : null,
                hinJoint:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinJoint) ||
                      null
                    : null,
                hinJointNm:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? hinJointDataOptions.find(
                        (item) => item['seq'] === props.detailForm.getFieldValue('hinJoint')
                      )?.keyData1 || null
                    : null,
                hinShape:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinShape) ||
                      null
                    : null,
                hinShapeNm:
                  props.juchuDetailData['hinKbn'] === '1'
                    ? hinShapeDataOptions.find(
                        (item) => item['seq'] === props.detailForm.getFieldValue('hinShape')
                      )?.keyData1 || null
                    : null,
                irogCd: props.juchuDetailData['irogCd'],
                // irogNm: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irogNm),
                hyoujiIroCd:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hyoujiIroCd) || '',
                kihonIroCd:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd) || '',
                haiCd: haiNm.split('.')[0] || null,
                haiCd2: haiNm.split('.')[1] || null,
                haiNm:
                  unsoDataOptions.find((item) => [item.haiCd, item.haiCd2].join('.') === haiNm)
                    ?.haiRnm +
                    unsoDataOptions.find((item) => [item.haiCd, item.haiCd2].join('.') === haiNm)
                      ?.haiRnm2 || '',
                haiUrlMae: urlData.data['haiUrlMae'] || null,
                haiUrlAto: urlData.data['haiUrlAto'] || null,
                syukkaDt:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.syukkaDt) || null,
                okuriNo:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.okuriNo) || null,
                genbutuNo:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo) || '',
                mihonNo:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.mihonNo) || '',
                kaijyoKbn:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaijyoKbn) || null,
                kaitoNm:
                  props.detailForm.getFieldValue('kaijyoKbn') === '0'
                    ? '確認中'
                    : props.detailForm.getFieldValue('kaijyoKbn') === '1'
                    ? '納期保留'
                    : props.detailForm.getFieldValue('kaijyoKbn') === '2'
                    ? '仮確定'
                    : props.detailForm.getFieldValue('kaijyoKbn') === '3'
                    ? '確定'
                    : null,
                kaitoDt: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoDt),
                ampmNm:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '1'
                    ? 'AM'
                    : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) ===
                      '2'
                    ? 'PM'
                    : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) ===
                      '3'
                    ? '頃'
                    : null,
                kaitoKbn:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) || null,
                // jyuSu: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.jyuSu),
                // nisugataKbn: props.form.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn),
                nisugataNm:
                  nisugataKbnDataOptions.find(
                    (item) => item['nisug'] === props.detailForm.getFieldValue('nisugataKbn')
                  )?.name || '',
                iroKbn: props.juchuDetailData['iroKbn'],
                iroBiko:
                  props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.iroBiko) || null,
                biko: props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.biko) || null,
              };
            }
            return item;
          });
        });
        JuchuDetailDataClear();
      }
    } else {
      notificationError('注文入力', Message.ERROR_MASSAGE.ERR010);
    }
    props.changeLoading(false);
  };

  // 明細編集削除ボタン処理
  const JuchuListDataDel = async () => {
    if (props.loading) return;
    props.changeLoading(true);
    props.updateJuchuListDelData([...props.juchuListDelData, props.juchuDetailData.jyugyoNo]);
    await props.updateJuchuListlData((list: any[]) => {
      return list.filter((item) => item.dispNo !== props.juchuDetailData.dispNo);
    });
    JuchuDetailDataClear();
    props.changeLoading(false);
  };

  // 明細編集セットバラシボタン処理
  const JuchuListDataSetBarasi = async () => {
    if (props.loading) return;
    props.changeLoading(true);
    let hinCd = props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.hinCd);
    if (
      await RequiredDetails(
        hinCd,
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irime),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.irimeKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.jyuSu),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.nisugataKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.mihonNo),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.genbutuNo),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.geniraiKbn),
        props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kihonIroCd)
      )
    ) {
      let hinData: any = await JuchuNyuryokuServ.checkHinmokuData(
        props.juchuData.tokCd,
        props.juchuData.tokCd2,
        hinCd
      );
      if (hinData.data === 'SUCCESS') {
        // useEffectが動くので変数に展開して代入
        let dispJuchuDetailData: JuchuDetailData = { ...props.juchuDetailData };
        // 画面表示項目を設定
        dispJuchuDetailData.hinCd = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hinCd
        );
        dispJuchuDetailData.hinNm = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hinNm
        );
        dispJuchuDetailData.irime = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.irime
        );
        dispJuchuDetailData.irimeKbn = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.irimeKbn
        );
        dispJuchuDetailData.irimeNm =
          irimeTaniDataOptions.find(
            (item) => item['irimeKbn'] === props.detailForm.getFieldValue('irimeKbn')
          )?.irimeNm || null;
        dispJuchuDetailData.tuyaCd = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.tuyaCd
        );
        dispJuchuDetailData.tuyaNm =
          tuyaDataOptions.find(
            (item) => item['tuyaCd'] === props.detailForm.getFieldValue('tuyaCd')
          )?.tuyaNm || null;
        dispJuchuDetailData.hinSize = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hinSize
        );
        dispJuchuDetailData.hinSizeNm =
          sizeDataOptions.find((item) => item['seq'] === props.detailForm.getFieldValue('hinSize'))
            ?.keyData1 || null;
        dispJuchuDetailData.hinJoint = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hinJoint
        );
        dispJuchuDetailData.hinJointNm =
          hinJointDataOptions.find(
            (item) => item['seq'] === props.detailForm.getFieldValue('hinJoint')
          )?.keyData1 || null;
        dispJuchuDetailData.hinShape = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hinShape
        );
        dispJuchuDetailData.hinShapeNm =
          hinShapeDataOptions.find(
            (item) => item['seq'] === props.detailForm.getFieldValue('hinShape')
          )?.keyData1 || null;
        dispJuchuDetailData.irogCd = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.irogCd
        );
        dispJuchuDetailData.hyoujiIroCd = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.hyoujiIroCd
        );
        dispJuchuDetailData.kihonIroCd = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.kihonIroCd
        );

        let haiNm: string =
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.haiNm) || '';
        dispJuchuDetailData.haiCd = haiNm.split('.')[0] || '';
        dispJuchuDetailData.haiCd2 = haiNm.split('.')[1] || '';
        dispJuchuDetailData.haiNm =
          unsoDataOptions.find((item) => [item.haiCd, item.haiCd2].join('.') === haiNm)?.haiRnm ||
          '';
        dispJuchuDetailData.syukkaDt = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.syukkaDt
        );
        dispJuchuDetailData.okuriNo = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.okuriNo
        );
        dispJuchuDetailData.genbutuNo = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.genbutuNo
        );
        dispJuchuDetailData.mihonNo = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.mihonNo
        );
        dispJuchuDetailData.kaijyoKbn = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.kaijyoKbn
        );
        dispJuchuDetailData.kaitoNm =
          props.detailForm.getFieldValue('kaijyoKbn') === '0'
            ? '確認中'
            : props.detailForm.getFieldValue('kaijyoKbn') === '1'
            ? '納期保留'
            : props.detailForm.getFieldValue('kaijyoKbn') === '2'
            ? '仮確定'
            : props.detailForm.getFieldValue('kaijyoKbn') === '3'
            ? '確定'
            : '';
        dispJuchuDetailData.kaitoDt = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.kaitoDt
        );
        dispJuchuDetailData.ampmNm =
          props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '1'
            ? 'AM'
            : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '2'
            ? 'PM'
            : props.detailForm.getFieldValue(JuchuDetailData.FIELD_KEY_NAME.kaitoKbn) === '3'
            ? '頃'
            : '';
        dispJuchuDetailData.kaitoKbn = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.kaitoKbn
        );
        dispJuchuDetailData.jyuSu = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.jyuSu
        );
        dispJuchuDetailData.nisugataKbn = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.nisugataKbn
        );
        dispJuchuDetailData.nisugataNm =
          nisugataKbnDataOptions.find(
            (item) => item['nisug'] === props.detailForm.getFieldValue('nisugataKbn')
          )?.name || null;
        dispJuchuDetailData.iroBiko = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.iroBiko
        );
        dispJuchuDetailData.biko = props.detailForm.getFieldValue(
          JuchuDetailData.FIELD_KEY_NAME.biko
        );

        let data: any = await JuchuNyuryokuServ.clickSetBarashi(
          props.juchuData.tokCd,
          props.juchuData.tokCd2,
          dispJuchuDetailData
        );
        props.updateJuchuListlData((list: any) => {
          let maxDispNo = Math.max(...list.map((item: any) => item['dispNo'])) + 1;
          return [
            ...list,
            ...data.data.map((item: JuchuDetailData, index: number) => {
              return {
                // ...item,
                dispNo: maxDispNo + index,
                processKbn: '1',
                hinCd: item.hinCd,
                hinNm: item.hinNm,
                hinKbn: item.hinKbn,
                irogNm: item.irogNm,
                irogCd: item.irogCd,
                irime: item.irime,
                irimeKbn: item.irimeKbn,
                irimeNm: item.irimeNm,
                tuyaCd: item.tuyaCd,
                tuyaNm: item.tuyaNm,
                hinSize: item.hinSize,
                hinShape: item.hinShape,
                hinJoint: item.hinJoint,
                hinSizeNm: item.hinSizeNm,
                hinShapeNm: item.hinShapeNm,
                hinJointNm: item.hinJointNm,
                hyoujiIroCd: item.hyoujiIroCd,
                kihonIroCd: item.kihonIroCd,
                jyuSu: item.jyuSu,
                nisugataKbn: item.nisugataKbn,
                nisugataNm: item.nisugataNm,
                inzu: item.inzu,
                kaitoDt: item.kaitoDt,
                kaitoKbn: item.kaitoKbn,
                ampmNm: item.ampmNm,
                kaijyoKbn: item.kaijyoKbn,
                kaitoNm: item.kaitoNm,
                haiNm: item.haiNm,
                haiUrlMae: item.haiUrlMae,
                haiUrlAto: item.haiUrlAto,
                okuriNo: item.okuriNo,
                syukkaDt: item.syukkaDt,
                mihonNo: item.mihonNo,
                geniraiKbn: item.geniraiKbn,
                genbutuNo: item.genbutuNo,
                iroBiko: item.iroBiko,
                biko: item.biko,
                iroKbn: item.iroKbn,
                setKbn: item.setKbn,
                haiCd: item.haiCd,
                haiCd2: item.haiCd2,
              };
            }),
          ];
        });
        JuchuDetailDataClear();
      } else {
        notificationError('注文入力', Message.ERROR_MASSAGE.ERR010);
      }
    }
    props.changeLoading(false);
  };

  // 明細編集クリアボタン処理
  const JuchuDetailDataClear = async () => {
    // 画面表示
    props.detailForm.resetFields();
    // 内部データ
    props.updateJuchuDetailData({});
    // 入目コンボボックスソース
    updateIrimeDataOptions([]);
    // 入目単位コンボボックスソース
    updateIrimeTaniDataOptions([]);
    // 数量単位コンボボックスソース
    updateNisugataKbnDataOptions([]);
    // 艶コンボボックスソース
    updateTuyaDataOptions([]);
    // サイズコンボボックスソース
    updateSizeDataOptions([]);
    // 形状コンボボックスソース
    updateHinShapeDataOptions([]);
    // 目地コンボボックスソース
    updateHinJointDataOptions([]);
    // 基本色調コンボボックスソース
    updateKihonIro('');
    updateKihonIroCdDataOptions([]);
    // 運送便コンボボックスソース
    updateUnsoData('');
    updateUnsoDataOptions([]);
    // 品目K区分
    updateHinmokuKbn('');
    // 現物色依頼区分
    updateGeniraiKbn('');
    // 製品ポップアップ
    updateSeihin('');
    // 色調ポップアップ
    updateColor([]);
    // 前回製品番号
    updateBefSeihin('');
  };

  // // 希望納期入力制限
  // const disabledDate = (current: any) => {
  //   return current && current < moment().add(-1, 'day');
  // };

  // 小数点以下入力制限
  const mathFloor = (number: any) => {
    props.detailForm.setFields([
      {
        name: ['jyuSu'],
        value: Math.floor(number),
      },
    ]);
  };
  //#endregion

  return (
    <>
      <ProductSearch
        tok_cd={props.juchuData.tokCd}
        tok_cd2={props.juchuData.tokCd2}
        cd={seihin}
        setCd={updateSeihin}
        visible={seihinPop}
        setVisible={updateSeihinPop}
      />
      <ColorSearch
        visibleState={colorPop}
        irogCd={props.juchuDetailData.irogCd}
        closeColor={closeColorPop}
        returnItem={updateColor}
      />
      <Form
        layout="horizontal"
        autoComplete="off"
        style={{ paddingTop: '1vh', backgroundColor: '#e6f7ff' }}
        form={props.detailForm}
      >
        {/* 行No.から現物色依頼まで */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item label="行No"></Form.Item>
          </Col>
          <Col xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.dispNo}>
              <Input className="clsReadOnly" maxLength={9} readOnly={true} />
            </Form.Item>
          </Col>
          <Col offset={1} xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item
              label="現物色依頼"
              name={JuchuDetailData.FIELD_KEY_NAME.geniraiKbn}
              valuePropName="checked"
            >
              <Checkbox
                checked
                onChange={ChgGeniraiKbn}
                disabled={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
              />
            </Form.Item>
          </Col>
          <Col offset={1}>
            {(() => {
              if (props.juchuDetailData.geniraiKbn === '1') {
                return <Form.Item>現物添付依頼書をメールに添付します。</Form.Item>;
              }
            })()}
          </Col>
        </Row>
        {/* 製品 */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item
              name={'hinlabel'}
              label={
                props.shoriSentaku === Const.SHORI_KBN.Create ||
                props.shoriSentaku === Const.SHORI_KBN.Edit ? (
                  props.juchuDetailData.setKbn !== '2' ? (
                    <Typography.Link
                      onClick={() => {
                        updateSeihinPop(true);
                      }}
                    >
                      製品
                    </Typography.Link>
                  ) : (
                    '製品'
                  )
                ) : (
                  '製品'
                )
              }
              rules={[
                {
                  required: true,
                  message: '',
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: '',
                },
              ]}
            ></Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.hinCd}
              rules={[
                {
                  required: true,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR001, '製品'),
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR017, '製品'),
                },
              ]}
            >
              <Input
                maxLength={15}
                onBlur={async () => {
                  if ((await chkHinCd()) === '0' || (await chkHinCd()) === '1') {
                    ChgHinCd();
                  }
                }}
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? props.juchuDetailData.setKbn !== '2'
                      ? false
                      : true
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? props.juchuDetailData.setKbn !== '2'
                      ? ''
                      : 'clsReadOnly'
                    : 'clsReadOnly'
                }
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.hinNm}>
              <Input className="clsReadOnly" maxLength={40} readOnly={true} />
            </Form.Item>
          </Col>
        </Row>
        {/* 入目から艶 */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item
              label="入目"
              name={JuchuDetailData.FIELD_KEY_NAME.irime}
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            ></Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.irime}
              rules={[
                {
                  required: true,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR001, '入目'),
                },
              ]}
            >
              <Select
                className="clsFontSize"
                onChange={ChgIrime}
                disabled={JuchuNyuryokuDetailCtrl1(props.shoriSentaku, Boolean(Number(hinmokuKbn)))}
                notFoundContent=" "
              >
                {irimeDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.irime}>
                      {item.irime}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1} style={{ marginRight: '10px' }}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.irimeKbn}
              rules={[
                {
                  required: true,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR001, '入目単位'),
                },
              ]}
            >
              <Select
                className="clsFontSize"
                disabled={JuchuNyuryokuDetailCtrl1(props.shoriSentaku, Boolean(Number(hinmokuKbn)))}
                onChange={() => {
                  props.updateJuchuDetailData({
                    ...props.juchuDetailData,
                    irimeKbn: props.detailForm.getFieldValue(
                      JuchuDetailData.FIELD_KEY_NAME.irimeKbn
                    ),
                  });
                }}
                notFoundContent=" "
              >
                {irimeTaniDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.irimeKbn}>
                      {item.irimeNm}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1} xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="艶"></Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.tuyaCd}>
              <Select
                className="clsFontSize"
                disabled={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                allowClear
                notFoundContent=" "
              >
                {tuyaDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.tuyaCd}>
                      {item.tuyaNm}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* サイズから目地まで */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item label="サイズ"></Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.hinSize}>
              <Select
                className="clsFontSize"
                disabled={!Boolean(Number(hinmokuKbn))}
                onChange={() => {
                  ChgSize();
                }}
                notFoundContent=" "
              >
                {sizeDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.seq}>
                      {item.keyData1}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1} xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="形状"></Form.Item>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.hinShape}>
              <Select
                className="clsFontSize"
                disabled={!Boolean(Number(hinmokuKbn))}
                notFoundContent=" "
              >
                {hinShapeDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.seq}>
                      {item.keyData1}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1} xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="目地"></Form.Item>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.hinJoint}>
              <Select
                className="clsFontSize"
                disabled={!Boolean(Number(hinmokuKbn))}
                notFoundContent=" "
              >
                {hinJointDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.seq}>
                      {item.keyData1}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* カタログ */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item label="カタログ"></Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.irogNm}>
              <Input className={'clsReadOnly'} readOnly={true} value={'カタログ'} />
            </Form.Item>
          </Col>
        </Row>
        {/* 色調から送り状No.まで */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item
              label={
                JuchuNyuryokuDetailCtrl2(
                  props.shoriSentaku,
                  Boolean(Number(props.juchuDetailData.geniraiKbn || 0)),
                  Boolean(Number(props.juchuDetailData.iroKbn))
                ) ? (
                  '色調'
                ) : (
                  <Typography.Link onClick={showColorPop}>色調</Typography.Link>
                )
              }
            ></Form.Item>
          </Col>
          <Col xxl={4} xl={2} lg={4} md={4} sm={4} xs={4}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.hyoujiIroCd}>
              <Input
                maxLength={20}
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? ''
                    : 'clsReadOnly'
                }
              />
            </Form.Item>
          </Col>
          <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1} style={{ marginLeft: '10px' }}>
            <Form.Item
              label="基本色調"
              name={JuchuDetailData.FIELD_KEY_NAME.kihonIroCd}
              rules={[
                {
                  required: geniraiKbn === '1' ? false : true,
                  message: '',
                },
              ]}
            ></Form.Item>
          </Col>
          <Col xxl={4} xl={2} lg={4} md={4} sm={4} xs={4}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.kihonIroCd}
              rules={[
                {
                  required: geniraiKbn === '1' ? false : true,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR001, '基本色調'),
                },
              ]}
            >
              <Select
                className="clsFontSize"
                onChange={ChgKihon}
                disabled={JuchuNyuryokuDetailCtrl3(
                  props.shoriSentaku,
                  Boolean(Number(props.juchuDetailData.geniraiKbn || 0))
                )}
                notFoundContent=" "
              >
                {kihonIroCdDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.mkiroCd}>
                      {item.mkiroCd}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1} style={{ marginLeft: '10px' }}>
            <Form.Item label="運送便"></Form.Item>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <Form.Item name="haiNm">
              <Select
                disabled={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                className={props.shoriSentaku === Const.SHORI_KBN.Create ? 'clsReadOnly' : ''}
                onChange={(e: any) => {
                  ChgHaiNm(e);
                }}
                allowClear
                notFoundContent=" "
              >
                {unsoDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={[item.haiCd, item.haiCd2].join('.')}>
                      {`${item.haiRnm || ''}${item.haiRnm2 || ''}`}
                      {/* {`${item.haiRnm || ''}`} */}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1} style={{ marginLeft: '10px' }}>
            <Form.Item label="出荷日"></Form.Item>
          </Col>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.syukkaDt}>
              <DatePicker
                locale={ja_JP}
                format={'YYYY/MM/DD'}
                // disabledDate={disabledDate}
                disabled={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                style={{
                  backgroundColor:
                    props.shoriSentaku === Const.SHORI_KBN.Edit ? 'white' : '#b5f5ec',
                }}
              />
            </Form.Item>
          </Col>
          <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1} style={{ marginLeft: '10px' }}>
            <Form.Item label="送り状No"></Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.okuriNo}
              rules={[
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR017, '送り状No'),
                },
              ]}
            >
              <Input
                maxLength={15}
                readOnly={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                className={props.shoriSentaku === Const.SHORI_KBN.Edit ? '' : 'clsReadOnly'}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 現物管理No.から回答納期まで */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item label="現物管理No"></Form.Item>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={3} sm={3} xs={3} style={{ marginRight: '10px' }}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.genbutuNo}
              rules={[
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR017, '現物管理No'),
                },
              ]}
            >
              <Input
                readOnly={JuchuNyuryokuDetailCtrl3(
                  props.shoriSentaku,
                  Boolean(Number(props.juchuDetailData.geniraiKbn || 0))
                )}
                className={
                  JuchuNyuryokuDetailCtrl3(
                    props.shoriSentaku,
                    Boolean(Number(props.juchuDetailData.geniraiKbn || 0))
                  )
                    ? 'clsReadOnly'
                    : ''
                }
                maxLength={10}
              />
            </Form.Item>
          </Col>
          <Col xxl={{ offset: 1, span: 1 }} xl={2} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="見本板No"></Form.Item>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={3} sm={3} xs={3} style={{ marginRight: '10px' }}>
            <Form.Item
              name={JuchuDetailData.FIELD_KEY_NAME.mihonNo}
              rules={[
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR017, '見本板No'),
                },
              ]}
            >
              <Input
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? ''
                    : 'clsReadOnly'
                }
                maxLength={10}
              />
            </Form.Item>
          </Col>
          <Col xxl={{ offset: 1, span: 1 }} xl={2} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="回答状況"></Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} style={{ marginRight: '10px' }}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.kaijyoKbn}>
              <Select
                className="clsFontSize"
                disabled={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                allowClear
                notFoundContent=" "
              >
                <Option value="0">確認中</Option>
                <Option value="1">納期保留</Option>
                <Option value="2">仮確定</Option>
                <Option value="3">確定</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xxl={{ offset: 2, span: 1 }} xl={2} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="回答納期"></Form.Item>
          </Col>
          <Col xxl={2} xl={3} lg={4} md={4} sm={4} xs={4}>
            <Col xxl={24} xl={22} lg={10} md={10} sm={10} xs={10}>
              <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.kaitoDt}>
                <DatePicker
                  locale={ja_JP}
                  format={'YYYY/MM/DD'}
                  disabled={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                  // disabledDate={disabledDate}
                  style={{
                    backgroundColor:
                      props.shoriSentaku === Const.SHORI_KBN.Edit ? 'white' : '#b5f5ec',
                  }}
                />
              </Form.Item>
            </Col>
          </Col>
          <Col xxl={2} xl={3} lg={4} md={4} sm={4} xs={4}>
            <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
              <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.kaitoKbn}>
                <Select
                  className="clsFontSize"
                  disabled={props.shoriSentaku === Const.SHORI_KBN.Edit ? false : true}
                  allowClear
                  notFoundContent=" "
                >
                  <Option value="1">AM</Option>
                  <Option value="2">PM</Option>
                  <Option value="3">頃</Option>
                </Select>
              </Form.Item>
            </Col>
          </Col>
        </Row>
        {/* 数量から色備考まで */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item
              label="数量"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
              name={JuchuDetailData.FIELD_KEY_NAME.jyuSu}
            ></Form.Item>
          </Col>
          <Col xxl={1} xl={2} lg={1} md={1} sm={1} xs={1}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: generateMessage(Message.ERROR_MASSAGE.ERR001, '数量'),
                },
              ]}
              name={JuchuDetailData.FIELD_KEY_NAME.jyuSu}
            >
              <InputNumber
                maxLength={5}
                min={0}
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? ''
                    : 'clsReadOnly'
                }
                onChange={(e) => mathFloor(e)}
              />
            </Form.Item>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} style={{ marginRight: '10px' }}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.nisugataKbn}>
              <Select
                disabled={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                notFoundContent=" "
              >
                {nisugataKbnDataOptions.map((item, index) => {
                  return (
                    <Option key={index} value={item.nisug}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1} xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}>
            <Form.Item label="色備考"></Form.Item>
          </Col>
          <Col xxl={16} xl={14} lg={16} md={16} sm={16} xs={16}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.iroBiko}>
              <TextArea
                rows={1}
                maxLength={100}
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? ''
                    : 'clsReadOnly'
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 備考 */}
        <Row>
          <Col xxl={2} xl={3} lg={2} md={2} sm={2} xs={2} style={{ left: 40 }}>
            <Form.Item label="備考"></Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
            <Form.Item name={JuchuDetailData.FIELD_KEY_NAME.biko}>
              <TextArea
                rows={3}
                maxLength={100}
                readOnly={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
                className={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? ''
                    : 'clsReadOnly'
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 追加・修正・削除・セットバラシ・クリアボタン */}
        <Row>
          <Col lg={{ offset: 11 }} xl={{ offset: 13 }} xxl={{ offset: 16 }}>
            <Space size={'large'}>
              <Button
                size={'large'}
                type="primary"
                onClick={JuchuListDataAdd}
                disabled={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
              >
                追加
              </Button>
              <Button
                size={'large'}
                type="primary"
                onClick={JuchuListDataUpd}
                disabled={JuchuNyuryokuDetailCtrl4(
                  props.shoriSentaku,
                  Boolean(Number(props.juchuDetailData.dispNo))
                )}
              >
                修正
              </Button>
              <Button
                size={'large'}
                type="primary"
                onClick={JuchuListDataDel}
                disabled={JuchuNyuryokuDetailCtrl4(
                  props.shoriSentaku,
                  Boolean(Number(props.juchuDetailData.dispNo))
                )}
              >
                削除
              </Button>
              {(() => {
                if (props.session.jishaKbn === '1') {
                  return (
                    <Button
                      size={'large'}
                      type="primary"
                      onClick={JuchuListDataSetBarasi}
                      disabled={JuchuNyuryokuDetailCtrl5(
                        props.juchuDetailData.setKbn,
                        props.juchuDetailData.barashiKbn
                      )}
                    >
                      セットバラシ
                    </Button>
                  );
                }
              })()}
              <Button
                size={'large'}
                type="primary"
                onClick={JuchuDetailDataClear}
                disabled={
                  props.shoriSentaku === Const.SHORI_KBN.Create ||
                  props.shoriSentaku === Const.SHORI_KBN.Edit
                    ? false
                    : true
                }
              >
                クリア
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default JuchuNyuryokuDetailEdit;
